module.exports = __webpack_public_path__ + "fonts/baronsans-bold-webfont.d92b6c1e.woff";